var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{ref:"modal",staticClass:"iande-group-modal",attrs:{"label":_vm.__('Detalhes do grupo', 'iande')},on:{"close":_vm.close}},[(_vm.group)?_c('GroupDetails',{attrs:{"educators":_vm.educators,"group":_vm.group}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }